import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { CashFlow } from './CashFlow';

@supertypeClass({ toClient: true, toServer: true })
export class Liability extends CashFlow {
  @property()
  subtype: string;

  @property({ rule: ['currency', 'numericPositive'] })
  amount: number;

  constructor() {
    super();
  }

  static new(customer, subtype: string, amount, title) {
    return new Liability().init(customer, subtype, amount, title);
  }

  init(customer, subtype: string, amount, title) {
    super.init(customer, 'liability', subtype, amount, title);
    return this;
  }

  inCashFlow() {
    return false;
  }

  getStartingFlow(): any {
    if (this.subtype === 'mortgage') {
      return {
        amount: this.amount * this.customer.capitalNeeds.payOffDebtsPercent,
      };
    }

    if (this.subtype === 'loan') {
      return {
        amount: this.amount * this.customer.capitalNeeds.payOffMortgagePercent,
      };
    }
    return {
      amount: this.amount,
    };
  }
}
